import type { IBlockageStatusValues } from "@/types/dryp/Blockage";

export const BLOCKAGE_STATUS_COLORS: Record<IBlockageStatusValues | "default", string> = {
	Blocked: "#ef4444",
	Warning: "#f97316",
	Normal: "#22c55e",
	Full: "#1d4ed8",
	NoData: "#6b7280",
	Undetermined: "#9ca3af",
	default: "#6b7280",
};

export const BLOCKAGE_STATUS_LABELS: Record<IBlockageStatusValues, string> = {
	Blocked: "Blocked",
	Warning: "Warning",
	Normal: "Normal",
	Full: "Full",
	NoData: "No data",
	Undetermined: "Undetermined",
};
